
// Necessary polyfill for Composition API support for IE11
import 'core-js/modules/es6.reflect.own-keys'

import { globalPlugin } from 'nuxt-composition-api'

export default globalPlugin
